export var oteljsVersion = '3.1.74';
//# sourceMappingURL=Version.js.map